import { ColumnLayout } from "@mittwald/flow-components/dist/components/ColumnLayout";
import { Text } from "@mittwald/flow-components/dist/components/Text";
import { TextField } from "@mittwald/flow-components/dist/components/TextField";
import { Section } from "@mittwald/flow-components/dist/components/Section";
import React from "react";

interface LoginInputsProps {
  isNewSystem: boolean;
  formError?: string | null;
}

export const LoginInputs: React.FC<LoginInputsProps> = ({
  isNewSystem,
  formError,
}) => {
  const passwordInput = (
    <TextField
      label="password"
      name="password"
      rules={{ required: true }}
      type="password"
    />
  );

  const oldSystem = (
    <ColumnLayout medium={[1, 1]}>
      <TextField
        label="customerNumber"
        name="identifier"
        rules={{ required: true, pattern: /^\d+$/ }}
      />
      {passwordInput}
    </ColumnLayout>
  );

  const newSystem = (
    <ColumnLayout medium={[1, 1]}>
      <TextField
        label="email"
        name="identifier"
        rules={{
          required: true,
        }}
        type="email"
      />
      {passwordInput}
    </ColumnLayout>
  );

  const loginInputs = (
    <>
      {isNewSystem ? newSystem : oldSystem}
      {formError && (
        <Text
          _color="status-error-default"
          _mt="s"
          i18n={{
            id: formError,
          }}
        />
      )}{" "}
    </>
  );

  return <Section.Item>{loginInputs}</Section.Item>;
};
